class LocalStorageService {
    // localStorage
    getLocalStorage(key) {
        let value = window.localStorage.getItem(key);
        try {
            value = JSON.parse(value);
        } catch (e) {
            console.log(e);
        }
        return value;
    }
    setLocalStorage(key, value) {
        if (Object.prototype.toString.call(value) === '[object String]') window.localStorage.setItem(key, value);
        if (typeof value === 'object') window.localStorage.setItem(key, JSON.stringify(value));
    }

    // sessionStorage
    getSessionStorage(key) {
        let value = window.sessionStorage.getItem(key);
        try {
            value = JSON.parse(value);
        } catch (e) {
            console.log(e);
        }
        return value;
    }
    setSessionStorage(key, value) {
        if (Object.prototype.toString.call(value) === '[object String]') window.sessionStorage.setItem(key, value);
        if (typeof value === 'object') window.sessionStorage.setItem(key, JSON.stringify(value));
    }

    // remove
    removeLocalStorage(key) {
        window.localStorage.removeItem(key);
    }
}

export default new LocalStorageService();



// WEBPACK FOOTER //
// ./src/utils/storage.js